const _excluded = ["existingContact", "refreshExistingContacts", "onChange", "onValidation", "showCustomerDetailsWarning"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import ContactPicker from "./ContactPicker";
import { ManageContactModalForVendor } from "../../ManageContactModal";
import { useGlobalContext, useStateInRef } from 'seagull';
import { useStoreActions } from "../../../store/store-context";
import { handlePromise } from "../../../infra/utils";
import { GridItem, TextButton } from 'seagull';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { NewContactModel } from "../../../models/ContactModel";
function calculateCanEditContact(existingContact) {
  return !!existingContact && existingContact.isEditable() && !existingContact.isSample();
}
export default function ContactDetails(props) {
  const {
      existingContact,
      refreshExistingContacts,
      onChange: _onChange,
      onValidation,
      showCustomerDetailsWarning
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const getProps = useStateInRef(_objectSpread(_objectSpread({}, props), {}, {
    openContactModal,
    newContactPostActions
  }));
  const globalContext = useGlobalContext();
  const {
    MULTIPLE_RECEPIENTS
  } = useFeatureFlags();
  const {
    api
  } = useStoreActions();
  const [canEditContact, setCanEditContact] = useState(calculateCanEditContact(existingContact));
  useEffect(() => {
    const newContact = NewContactModel.makeEmpty();
    if (newContact.hasPartialContactDetails() && !existingContact) {
      handlePromise(api.contact.create(newContact)).then(async newContact => {
        if (newContact.success) {
          await getProps().newContactPostActions(newContact.data);
        } else {
          const savedContact = await getProps().openContactModal({
            newContactToCreate: newContact.data
          });
          await getProps().newContactPostActions(savedContact);
        }
      });
    }
    setCanEditContact(calculateCanEditContact(existingContact));
  }, [existingContact]);
  async function openContactModal(props) {
    return globalContext.showModal({
      closeOnEscapeKey: false,
      closeOnClickOutside: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ManageContactModalForVendor, _extends({}, props, {
          "data-testid": "manage-contact-modal",
          onClose: dismissModal,
          origin: "Agreement studio"
        }));
      }
    });
  }
  async function newContactPostActions(savedContact) {
    if (savedContact) {
      await refreshExistingContacts();
      onValidation(true);
      _onChange({
        type: 'existingContact',
        id: savedContact.id()
      });
    } else {
      onValidation(false);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridItem, {
    span: 9
  }, /*#__PURE__*/React.createElement(ContactPicker, {
    label: MULTIPLE_RECEPIENTS ? 'Primary contact' : 'Contact',
    value: existingContact !== null && existingContact !== void 0 ? existingContact : NewContactModel.makeEmpty(),
    onChange: async change => {
      switch (change.type) {
        case 'existingContact':
          onValidation(true);
          _onChange({
            type: 'existingContact',
            id: change.id
          });
          break;
        case 'newContact':
          {
            const savedContact = await openContactModal({});
            await newContactPostActions(savedContact);
            break;
          }
        case 'sampleContact':
          onValidation(true);
          _onChange({
            type: 'sampleContact'
          });
          break;
        default:
          break;
      }
    },
    "data-testid": rest['data-testid'],
    error: showCustomerDetailsWarning,
    helperText: "Please select a contact"
  })), /*#__PURE__*/React.createElement(GridItem, {
    span: 3
  }, canEditContact && /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "edit-contact",
    onClick: async () => {
      const shouldRefresh = await openContactModal({
        existingContact
      });
      if (shouldRefresh) {
        await refreshExistingContacts();
      }
    }
  }, "Edit contact")));
}